import React, { useEffect } from "react";
import DestinationPlaces from "../components/destination/DestinationPlaces";
import CommonHero from "../components/common/CommonHero";
import DestinationImage from "../../src/assets/img/destination-image.webp"
import GetTheBestTravelDeal from "../components/common/GetTheBestTravelDeal";

const DestinationPage = () => {
   useEffect(() => {
        document.getElementById("title-page").innerHTML = "TripNest | Destinations";
      }, []);
  return <div>
    <CommonHero imgUrl={DestinationImage} text={"Destinations"}/>
    <DestinationPlaces />
    <GetTheBestTravelDeal/>
  </div>;
};

export default DestinationPage;
